const cards = [
  {
    title: '《炎之轨迹》第二季',
    tag: '热血战斗',
    desc: '延续第一季的燃爆剧情，主角团踏上新的冒险征程，战斗场面全面升级。',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20illustration%20with%20fire%20element%20warrior%20character%20in%20battle%20pose%20warm%20orange%20and%20red%20flames%20dramatic%20lighting%20epic%20composition%20cinematic%20style&width=800&height=600&seq=cards-fire-trail&orientation=landscape',
    alt: '炎之轨迹第二季动漫',
  },
  {
    title: '《恋空物语》',
    tag: '恋爱甜宠',
    desc: '高中校园纯爱故事，樱花树下的约定，温暖治愈每一帧都甜到心底。',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20romantic%20anime%20illustration%20with%20couple%20under%20cherry%20blossom%20tree%20school%20uniform%20soft%20pink%20lighting%20dreamy%20atmosphere%20spring%20setting&width=800&height=600&seq=cards-love-sky&orientation=landscape',
    alt: '恋空物语恋爱动漫',
  },
  {
    title: '《异世界转生录》',
    tag: '异世界冒险',
    desc: '普通社畜转生异世界成为勇者，搞笑与热血并存的奇幻冒险之旅。',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20illustration%20with%20adventurer%20character%20in%20magical%20world%20colorful%20landscape%20warm%20golden%20lighting%20whimsical%20atmosphere%20adventure%20theme&width=800&height=600&seq=cards-isekai-reborn&orientation=landscape',
    alt: '异世界转生录冒险动漫',
  },
  {
    title: '《日常不思议》',
    tag: '搞笑日常',
    desc: '四个高中女生的爆笑日常，每一集都笑到肚子疼的轻松搞笑番剧。',
    img: 'https://readdy.ai/api/search-image?query=Cheerful%20anime%20illustration%20with%20group%20of%20school%20girls%20laughing%20bright%20classroom%20setting%20warm%20sunlight%20colorful%20slice%20of%20life%20style%20joyful%20atmosphere&width=800&height=600&seq=cards-daily-fun&orientation=landscape',
    alt: '日常不思议搞笑动漫',
  },
  {
    title: '《深夜侦探社》',
    tag: '悬疑推理',
    desc: '校园侦探社团破解连环谜案，每集一个案件，烧脑推理让人欲罢不能。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20anime%20illustration%20with%20detective%20club%20members%20in%20dark%20library%20warm%20desk%20lamp%20lighting%20noir%20atmosphere%20suspenseful%20composition&width=800&height=600&seq=cards-detective&orientation=landscape',
    alt: '深夜侦探社悬疑动漫',
  },
  {
    title: '《猫与咖啡店》',
    tag: '治愈温情',
    desc: '老街角猫咖的温暖故事，人与猫的日常治愈番，看完心里暖暖的。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20warm%20anime%20illustration%20of%20cat%20cafe%20interior%20with%20fluffy%20cats%20soft%20sunlight%20through%20windows%20healing%20atmosphere%20pastel%20color%20palette%20peaceful%20vibe&width=800&height=600&seq=cards-cat-cafe&orientation=landscape',
    alt: '猫与咖啡店治愈动漫',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门番剧
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            当前最受追捧的热门连载动漫，快来加入追更大军
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <a
              key={i}
              href="#ranking"
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 font-heading">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    每周更新
                  </span>
                  <span className="text-xs text-primary-600 font-medium group-hover:underline whitespace-nowrap">
                    追更详情 →
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}